/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Redirect } from 'react-router';
// material
import { Division, PrivateRoute } from '@insticator/insticator-ui'; // iui-material
// pages
import ModerationConfigPage from './moderationconfig/moderationconfig';
// styles
import injectSheet from 'react-jss';
import styles from './moderation_styles';


/* ========== ~~~~~~~~~~ MODERATION DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
  const { mocked, userEmail, mockupGenerator } = useSelector(state => state.session);
  const { accountProductsReceived, accountProducts, accountProductRequestStatus } = useSelector(state => state.account);
  const isInsticatorUser = mocked || /@insticator.com\s*$/.test(userEmail)
  const hasCommentingV2 = accountProducts.includes('COMMENTING_V2')

  const permittedToConfig = hasCommentingV2 && accountProductsReceived

  return (
    <Division name={`moderation`} klass={props.classes.moderation}>
      <Switch>
        {/*Routes to subdivisions*/}
        <PrivateRoute permitted={permittedToConfig} exact path={'/dashboard/moderation/config'} component={ModerationConfigPage} />
        <Redirect to='/error/404'/>
      </Switch>
    </Division>
  )
})